import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import DrawerInstruments from "../DrawerInstruments";
import ZoomedImg from "./ZoomedImg";
import style from "./canvas.module.scss";
import MoutainCharacteristic from "../MountainCharacteristic";

class Canvas extends Component {
  state = {
    painting: false,
    imageUrl: "",
    points: [],
    startPointX: 0,
    startPointY: 0,
    instrumentType: null,
    layers: []
  };

  canvasRef = createRef();
  imgRef = createRef();

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.painting &&
      !this.state.painting &&
      this.state.instrumentType !== "point" &&
      this.props.isOpenDrawInstruments
    ) {
      this.handleSetNewLayer();
    }
  }

  takeSnapshot = () => {
    this.snapshot = this.ctx.getImageData(0, 0, this.WIDTH, this.HEIGHT);
  };

  restoreSnapShot = () => {
    this.ctx.putImageData(this.snapshot, 0, 0);
  };

  handleSetNewLayer = () => {
    const dataUrl = this.canvas.toDataURL();
    this.setState(({ layers }) => ({
      layers: [...layers, dataUrl]
    }));
  };

  handleCutLastLayer = () => {
    const { layers } = this.state;

    const copyLayers = [...layers];
    copyLayers.pop();
    this.setState({
      layers: copyLayers
    });
  };

  draw = e => {
    const { instrumentType } = this.state;
    const { painting } = this.state;
    const { layerX, layerY } = e.nativeEvent;

    if (instrumentType === "brush") {
      if (painting) {
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineCap = "round";
        this.ctx.strokeStyle = this.color;

        this.ctx.lineTo(layerX, layerY);
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.moveTo(layerX, layerY);
      } else {
        this.ctx.beginPath();
      }
    }

    if (instrumentType === "line") {
      if (painting) {
        this.restoreSnapShot();
        const { startPointX, startPointY } = this.state;

        this.ctx.lineWidth = this.lineWidth;
        this.ctx.lineCap = "round";
        this.ctx.strokeStyle = this.color;

        this.ctx.beginPath();
        this.ctx.moveTo(startPointX, startPointY);
        this.ctx.lineTo(layerX, layerY);
        this.ctx.stroke();
      }
    }
  };

  setPoint = e => {
    const { instrumentType } = this.state;
    if (instrumentType === "point") {
      const { layerX, layerY } = e.nativeEvent;

      this.setState(prevState => {
        const hardcodeId = layerX + layerY;
        return {
          points: [
            ...prevState.points,
            { hardcodeId, topCoords: layerY, leftCoords: layerX }
          ]
        };
      });
    }
  };

  handleDeletePoint = id => {
    const { points } = this.state;
    this.setState({
      points: points.filter(el => el.hardcodeId !== id)
    });
  };

  startPosition = e => {
    const { layerX, layerY } = e.nativeEvent;
    const { instrumentType } = this.state;

    if (instrumentType === "line") {
      this.takeSnapshot();
    }

    this.setState({
      painting: true,
      startPointX: layerX,
      startPointY: layerY
    });
  };

  stopPosition = () => {
    this.setState({
      painting: false
    });
  };

  // **********************************************
  handleChangeInstruments = (e, newInstument) => {
    this.setState({
      instrumentType: newInstument
    });
  };

  render() {
    const { instrumentType } = this.state;
    const { isOpenDrawInstruments } = this.props;

    const renderDrawInstruments = isOpenDrawInstruments ? (
      <DrawerInstruments
        handleChangeInstruments={this.handleChangeInstruments}
        instrumentType={instrumentType}
        handleCutLastLayer={this.handleCutLastLayer}
      />
    ) : null;

    return (
      <>
        {this.props.map && this.props.map.map_path && (
          <ZoomedImg img={this.props.map.map_path} />
        )}

        <div className={style.instrumentsAbsolute}>
          {renderDrawInstruments}
          <MoutainCharacteristic />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    isOpenDrawInstruments: state.modals.isDrawInstrumentsOpen,
    map: state.map.map,
  };
};

export default connect(mapStateToProps)(Canvas);
